import { render, staticRenderFns } from "./DoublePostTitle.vue?vue&type=template&id=5a40313d"
import script from "./DoublePostTitle.vue?vue&type=script&lang=js"
export * from "./DoublePostTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports